module.exports = __webpack_public_path__ + "img/-e-location_title_decorate@2x.32d74ffb.png";